import { render } from "./ComplianceReviewDialog.vue?vue&type=template&id=c3204eae"
import script from "./ComplianceReviewDialog.vue?vue&type=script&lang=js"
export * from "./ComplianceReviewDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__